/* eslint-disable no-useless-escape */
import { useEffect, useState, useCallback } from "react";
import { Row, Col } from "react-flexbox-grid";
import { Button } from "components/core";
import { PageWrapper } from "components";
import { useGlobalContext } from "context/GlobalContext";
import { withLoader } from "HOC";
import AddToCalendar from "@culturehq/add-to-calendar";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import { useHistory, useParams } from "react-router-dom";
import {
  getMessageByStatus,
  REGISTER,
  ASSIGNED,
  CONFIRMED_ASSISTANCE,
  COLOR_PRIMARY,
} from "constants/index";

import { fetchBackend, removeHours } from "helpers";
import styled from "styled-components";

import "@culturehq/add-to-calendar/dist/styles.css";

const StyledContentCalendar = styled(Col)`
  .chq-atc {
    width: 100% !important;
  }

  button {
    color: inherit;
    border: 0;
    cursor: pointer;
    margin: 0;
    display: inline-flex;
    outline: 0;
    padding: 0;
    position: relative;
    align-items: center;
    user-select: none;
    border-radius: 0;
    vertical-align: middle;
    -moz-appearance: none;
    justify-content: center;
    text-decoration: none;
    background-color: transparent;
    -webkit-appearance: none;
    -webkit-tap-highlight-color: transparent;

    background: ${COLOR_PRIMARY} !important;
    color: #fff;
    padding: 8px 22px;
    font-size: 0.9375rem;
    min-width: 64px;
    box-sizing: border-box;
    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 500;
    line-height: 1.75;
    border-radius: 4px;
    letter-spacing: 0.02857em;
    text-transform: uppercase;
    width: 100% !important;
    max-width: 100% !important;
  }

  button:hover,
  button:focus,
  button:active {
    background: ${COLOR_PRIMARY} !important;
  }

  svg {
    display: none;
  }
`;

const SingleVaccine = ({ setLoading }) => {
  const [currentStep, setStep] = useState(1);
  const [currentVaccine, setVaccine] = useState(false);
  const gContext = useGlobalContext();
  const { id } = useParams();

  const getVaccine = useCallback(async () => {
    const { error, response } = await fetchBackend({
      url: `vaccine/${id}`,
    });

    if (!error) {
      console.log(response);
      // setCompletedForm(response.length > 0);
      setVaccine(response[0]);
    } else {
      gContext.toggleAlert({
        message:
          "Hubo un error al intentar obtener la información, revisa tu conexión a internet",
        type: "error",
      });
    }
  }, [id]);

  const getInitialState = useCallback(async () => {
    if (id) {
      await Promise.all([getVaccine()]);
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    getInitialState();
  }, []);

  return (
    <PageWrapper
      header={
        <Row start="xs">
          <Col md={12}>
            <Row center="xs">
              <h1>Programa de vacunación</h1>
            </Row>
          </Col>
        </Row>
      }
    >
      <>
        <PageListVaccine
          currentVaccine={currentVaccine}
          setStep={setStep}
          currentStep={currentStep}
        />
      </>
    </PageWrapper>
  );
};

export default withLoader(SingleVaccine, "Cargando detalles de registro");

const PageListVaccine = ({ currentVaccine, setStep, currentStep }) => {
  if (currentStep !== 1) return null;

  const {
    status,
    name,
    motherLastName,
    fatherLastName,
    birthDay,
    curp,
    vaccinationPlace,
  } = currentVaccine;

  return (
    <Row center="xs" middle="xs" className="w-100">
      <Col md={12}>
        <Row>
          <Col md={12}>
            <Row end="xs">
              <Col md={12} className="mb3">
                <List className="w-100">
                  <ListItem>
                    <ListItemText primary="Estatus" />
                    <ListItemSecondaryAction>{status}</ListItemSecondaryAction>
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Nombre" />
                    <ListItemSecondaryAction>{name}</ListItemSecondaryAction>
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Apellido paterno" />
                    <ListItemSecondaryAction>
                      {fatherLastName}
                    </ListItemSecondaryAction>
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Apellido materno" />
                    <ListItemSecondaryAction>
                      {motherLastName}
                    </ListItemSecondaryAction>
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Fecha de nacimiento" />
                    <ListItemSecondaryAction>
                      {new Date(birthDay).toLocaleDateString()}
                    </ListItemSecondaryAction>
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Curp" />
                    <ListItemSecondaryAction>{curp}</ListItemSecondaryAction>
                  </ListItem>
                </List>
              </Col>
            </Row>
          </Col>
        </Row>
        <ShowMessagingByStatus
          status={status}
          vaccinationPlace={vaccinationPlace}
        />
        <SectionAction {...currentVaccine} setStep={setStep} />
      </Col>
    </Row>
  );
};

const ShowMessagingByStatus = ({ status, vaccinationPlace }) => {
  const { color, message } = getMessageByStatus(status);

  if (status === CONFIRMED_ASSISTANCE) {
    return (
      <ComingSoonVaccine
        date={vaccinationPlace?.date}
        item={vaccinationPlace?.VaccineCenter}
      />
    );
  }

  return (
    <Row>
      <Col md={12}>
        <Typography variant="body1" color={color}>
          {message}
        </Typography>
      </Col>
    </Row>
  );
};

const SectionAction = ({ status, setStep, _id, ...rest }) => {
  if (status !== REGISTER && status !== ASSIGNED) return null;

  const history = useHistory();
  const isRegister = status === REGISTER;
  const onClick = isRegister
    ? () => setStep(2)
    : () => history.push(`/vacunas/horario/${_id}`);
  const textBtn = isRegister ? "Pagar vacuna" : "Escoger";

  return (
    <Row center="xs" className="mt3 mb3">
      <Col md={12}>
        <Button
          variant="contained"
          color="primary"
          className="w-100"
          onClick={onClick}
        >
          {textBtn}
        </Button>
      </Col>
    </Row>
  );
};

const ComingSoonVaccine = ({ date, item = {} }) => {
  const { direction, coordinates } = item;

  const openLocationCenter = () => {
    const linkMap = `https://maps.google.com/?q=${coordinates?.latitude},${coordinates?.longitude}`;
    window.open(linkMap);
  };

  return (
    <Row start="xs" className="w-100">
      <Col md={12} className="mt4">
        <Row>
          <Col md={12}>
            <Typography variant="h4">Felicidades</Typography>
          </Col>
          <Col md={12}>
            <Typography variant="body1">
              Tu fecha de vacunación es la siguiente:&nbsp;
              {new Date(date).toLocaleString()}
            </Typography>
          </Col>
        </Row>
        <Row start="xs" className="mt2">
          <Col md={12}>
            <Typography variant="h6">Recomendaciones</Typography>
          </Col>
          <Col md={12}>
            <Typography variant="body1">
              No olvides desayunar y tomar tus medicamentos antes de llegar al
              centro de vacunación, también evita llegar con mucha anticipación
              para evitar tiempos largos de espera.
            </Typography>
          </Col>
          <Col md={12}>
            <Typography variant="body1">
              Es muy importante mantener una buena hidratación sobre todo en
              zonas de calor.
            </Typography>
          </Col>
          <Col md={12}>
            <Typography variant="body1">
              El registro en las comunidades rurales será através de los Centros
              Integradores del Desarrollo o de la visigta de los servidores de
              la nación a las comunidades.
            </Typography>
          </Col>
        </Row>
        <Row center="xs" className="mt4">
          <StyledContentCalendar md={6}>
            <AddToCalendar
              event={{
                name: "Cita de vacunación COVID19 | México Seguro",
                details:
                  "Recuerda llegar 45 minutos antes para agilizar la aplicación de la vacuna. Muchas gracias por su confianza.",
                location: direction,
                startsAt: new Date(removeHours(date, 1)).toISOString(),
                endsAt: new Date(date).toISOString(),
              }}
            >
              AGREGAR EN MI TELEFONO
            </AddToCalendar>
          </StyledContentCalendar>
          <Col md={6}>
            <Button
              color="secondary"
              className="w-100"
              onClick={openLocationCenter}
            >
              Ver ubicación
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
